import React from "react";

const LABELS = {
    lastPeriod: "Premier jour des dernières règles",
    startPregnancy: "Date de début de grossesse",
    endPregnancy: "Date prévue d'accouchement",
};

export default function InputDate({ dateOption, inputDate, handleInputDateChange }) {
    return (
        <div className="flex flex-col gap-1">
            <label htmlFor="inputDate" className="text-sm font-semibold">{LABELS[dateOption]}</label>
            {/* min/max keep the native picker from accepting 5-digit years. */}
            <input
                type="date"
                value={inputDate}
                onChange={handleInputDateChange}
                className="dropdown min-w-32 sm:max-w-56"
                id="inputDate"
                name="inputDate"
                min="2000-01-01"
                max="2100-12-31"
                aria-required="true"
            ></input>
        </div>
    )
}
